import { TMW } from "./actions";
import initialState from "../../../../reducers/initialState";

const TeamWorkReducer = (state = initialState, action) => {
  switch (action.type) {
    //initialState
    case TMW.NEW_TEAM_WORKMODAL: {
      return {
        ...state,
        NewTeamWorkModal: !state.NewTeamWorkModal,
        contractsList: action.contracts,
        contractsPager: action.pager
      };
    }
    case TMW.CLOSE_NEW_TEAM_WORKMODAL: {
      return {
        ...state,
        NewTeamWorkModal: !state.NewTeamWorkModal,
        contractsList: [],
        contractsPager: {},
        selectedContract: null
      };
    }
    case TMW.ADD_NEW_USER_MODAL: {
      return {
        ...state,
        addNewUserModalModal: !state.addNewUserModalModal,
        usersList: action.users,
        usersPager: action.pager
        //selectedUsers: action.ExistUsers
      };
    }
    case TMW.CLOSE_ADD_NEW_USER_MODAL: {
      return {
        ...state,
        addNewUserModalModal: !state.addNewUserModalModal,
        selectedUsers: [],
        usersList: [],
        usersPager: {}
      };
    }
    case TMW.ADD_RULE_MODAL: {
      return {
        ...state,
        addRuleModal: !state.addRuleModal,
        selectedCurrentUser: action.user,
        currentTeamWorkId: action.teamWorkId
      };
    }
    case TMW.CLOSE_ADD_RULE_MODAL: {
      return {
        ...state,
        addRuleModal: !state.addRuleModal,
        selectedCurrentUser: {},
        currentTeamWorkId: 0
      };
    }
    case TMW.ADD_PRODUCT_GROUPS_MODAL: {
      return {
        ...state,
        addProductGroupsModal: !state.addProductGroupsModal,
        nestedProductGroups: action.nestedProductGroups,
        selectedCurrentUser: action.user,
        currentTeamWorkId: action.teamWorkId
      };
    }
    case TMW.CLOSE_ADD_PRODUCT_GROUPS_MODAL: {
      return {
        ...state,
        addProductGroupsModal: !state.addProductGroupsModal,
        nestedProductGroups: [],
        selectedCurrentUser: {}
        //currentTeamWorkId: 0
      };
    }
    case TMW.UPDATE_CONTRACTS: {
      return {
        ...state,
        contractsList: action.contracts,
        selectedContract: action.contract,
        contractsPager: action.pager
      };
    }
    case TMW.SELECT_CONTRACT: {
      return {
        ...state,
        selectedContract: action.contract
      };
    }
    case TMW.CANCEL_SELECT_CONTRACT: {
      return {
        ...state,
        contractsList: action.contracts,
        selectedContract: null
      };
    }
    case TMW.UPDATE_USERS_LIST: {
      return {
        ...state,
        usersList: action.users,
        usersPager: action.pager
      };
    }
    case TMW.UPDATE_TEAM_WORKS: {
      return {
        ...state,
        teamWorks: action.teamWorks,
        teamWorksPager: action.pager
      };
    }
    case TMW.UPDATE_SELECTED_USERS_LIST: {
      return {
        ...state,
        selectedUsers: action.selectedUsers,
        usersList: action.usersList
      };
    }
    case TMW.UPDATE_TEAMWORK_INFO: {
      return {
        ...state,
        teamWorkInfo: action.data
      };
    }
    case TMW.USER_PERMISSON_INITIAL_STATE: {
      return {
        ...state
        //teamWorkInfo: [],
        //selectedTeamWork: {}
      };
    }
    case TMW.UPDATE_SELECTED_TEAMWORK: {
      return {
        ...state,
        selectedTeamWork: action.teamWork
      };
    }
    case TMW.UPDATE_ADDED_NEW_USERS: {
      let _teamWorkInfo = [];
      if (state.teamWorkInfo.length > 0) {
        _teamWorkInfo = [...state.teamWorkInfo];
        let arr = [...action.newusers];
        arr.map((item, index) => {
          _teamWorkInfo.push(item);
        });
      } else {
        let arr = [...action.newusers];
        arr.map((item, index) => {
          _teamWorkInfo.push(item);
        });
      }

      return {
        ...state,
        teamWorkInfo: _teamWorkInfo
      };
    }
    case TMW.UPDATE_SELECTED_PRODUCT_GROUPS_ITEMS: {
      return {
        ...state,
        selectedProductGroupsItems: action.selectedProductGroupsItems
      };
    }
    case TMW.WORK_GROUPS_MANAGEMENT_MODAL: {
      return {
        ...state,
        WorkGroupsManagementModal: !state.WorkGroupsManagementModal,
      };
    }
    case TMW.CHANGE_TEAM_WORK_START: {
      return {
        ...state,
        Loading: true,
      };
    }
    case TMW.CHANGE_TEAM_WORK_END: {
      return {
        ...state,
        Loading: false,
      };
    }
    case TMW.CONFIRM_WORKGROUPS_MANAGEMENT_MODAL: {
      return {
        ...state,
        WorkGroupsManagementModal: false,
      };
    }
    case TMW.SET_CURRENT_TEAMWORK_DASHBOARD: {
      return {
        ...state,
        currentTeamWork: action.currentTeamWork,
      };
    }

    //-------Document Group Limitation----------------------------------

    case TMW.SET_USER_DOCUMENTGROUP: {
      return {
        ...state,
        selectedCurrentUser: action.selectedCurrentUser,
        openDocumentGroup: true
      };
    }

    case TMW.CLOSE_USER_DOCUMENTGROUP: {
      return {
        ...state,
        selectedCurrentUser: {},
        openDocumentGroup: false
      };
    }

    //-------Product Group Limitation--------------------------------

    case TMW.SET_USER_PRODUCTGROUP: {
      return {
        ...state,
        selectedCurrentUser: action.selectedCurrentUser,
        openProductGroup: true
      };
    }

    case TMW.CLOSE_USER_PRODUCTGROUP: {
      return {
        ...state,
        selectedCurrentUser: {},
        openProductGroup: false
      };
    }
      
         //-------Operation Group Limitation--------------------------------
       case TMW.SET_USER_OPERATIONGROUP: {
      return {
        ...state,
        selectedCurrentUser: action.selectedCurrentUser,
        openOperationGroup: true
      };
    }

    case TMW.CLOSE_USER_OPERATIONGROUP: {
      return {
        ...state,
        selectedCurrentUser: {},
        openOperationGroup: false
      };
    }
      
      
      


    default:
      return state;
  }
};

export default TeamWorkReducer;
